import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import RecordDetail from '../Record/RecordDetailPage';
import RecordGridLayoutView from './RecordGridLayoutView';
import ApiService from '../Components/apiService';
import { BASE_URL } from '../Components/Constant';
import { Spin, notification } from 'antd';

const ShowGridLayout = () => {
  const navigate = useNavigate(); // ✅ fixed
  const { id, objectName } = useParams();
  const [gridLayoutData, setGridLayoutData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [api, contextHolder] = notification.useNotification(); // ✅ notification hook
  const [alerts,setAlerts]=useState([]);

  useEffect(() => {
    const fetchAlerts = async () => {
      try {
        const apiService = new ApiService(
          `${BASE_URL}/check_alert_rules/${objectName}/${id}`,
          {},
          "GET"
        );
        const response = await apiService.makeCall();
        const rules = response.satisfied_rules || [];
        setAlerts(rules);
        rules.forEach(rule => {
          const type = rule.alert_type?.toLowerCase(); // error, info, success, warning
          if (['error', 'info', 'success', 'warning'].includes(type)) {
            api[type]({
              key: rule._id || rule.alert_type, 
              message: rule.alert_type.toUpperCase(), // show type as title
              description: rule.error_message, // error_message as content
              showProgress: true,
              pauseOnHover: true,
            });
          }
        });
      } catch (error) {
        console.error("Error fetching alerts:", error);
      }
    };

    fetchAlerts();
  }, [objectName, id]); // ✅ include id dependency

  useEffect(() => {
    fetchGridLayout();
  }, [objectName]);

  const fetchGridLayout = async () => {
    setLoading(true);
    const gridLayout = new ApiService(
      `${BASE_URL}/get_grid_layout_by_object/${objectName}`,
      {},
      'GET'
    );
    const response = await gridLayout.makeCall(navigate);
    setGridLayoutData(response);
    setLoading(false);
  };

  return (
    <>
      {contextHolder} {/* ✅ must be inside JSX */}
      {loading ? (
        <Spin />
      ) : (
        gridLayoutData && gridLayoutData._id !== undefined ? (
          <RecordGridLayoutView
            gridLayoutData={gridLayoutData}
            objectName={objectName}
            recordId={id}
            alerts={alerts}
          />
        ) : (
          <RecordDetail id={id} objectName={objectName} />
        )
      )}
    </>
  );
};

export default ShowGridLayout;
